import { useSessionStore } from "Common/Stores";
import { useFormik as useFormic } from "formik";
import { Login } from "interfaces";
import { layoutStore } from "Layout/VerticalLayout/store/layoutMenu.store";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LoginService } from "services";
import * as Yup from "yup";
import { useStore } from "zustand";

export const useLogin = () => {
  const navigate = useNavigate();
  const { setSession, session, clearSession, setIsAuthtenticated } =
    useSessionStore();

  const [{ success, error, errorMessage }, setIsLogued] = useState({
    success: false,
    error: false,
    errorMessage: "",
  });

  const {
    triggerRefreshMenu
  } = useStore(layoutStore);

  const [isSubmitLogin, setIsSubmitLogin] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    const bodyElement = document.body;

    bodyElement.classList.add(
      "flex",
      "items-center",
      "justify-center",
      "min-h-screen",
      "py-16",
      "lg:py-10",
      "bg-slate-50",
      "dark:bg-zink-800",
      "dark:text-zink-100",
      "font-public"
    );

    return () => {
      bodyElement.classList.remove(
        "flex",
        "items-center",
        "justify-center",
        "min-h-screen",
        "py-16",
        "lg:py-10",
        "bg-slate-50",
        "dark:bg-zink-800",
        "dark:text-zink-100",
        "font-public"
      );
    };
  }, []);

  useEffect(() => {
    if (session?.token) {
      clearSession();
    }
  }, []);

  const validation: any = useFormic({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required(t("validationForms.required")),
      password: Yup.string().required(t("validationForms.required")),
    }),
    onSubmit: async (values: any) => {
      setIsSubmitLogin(true);
      triggerRefreshMenu();
      const payload: Login = {
        user: values.email,
        password: values.password,
      };
      const response = await LoginService(payload);
      if (response.code === "200") {
        setSession(response.data);
        if (response.data.user.firstEntry === 1) {
          setIsLogued({ success: true, error: false, errorMessage: "" });
          navigate("/reset-password");

          return;
        }

        setIsLogued({ success: true, error: false, errorMessage: "" });
        setTimeout(() => {
          setIsAuthtenticated(true);
          navigate("/home");
          setIsSubmitLogin(false);
        }, 1500);
      } else {
        setIsSubmitLogin(false);
        setIsLogued({
          success: false,
          error: true,
          errorMessage: response.message,
        });
      }
    },
  });

  return {
    validation,
    success,
    error,
    errorMessage,
    isSubmitLogin,
    navigate,
    t,
  };
};
